declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

export const trackMetaPixelEvent = (
  eventName: string,
  params?: Record<string, unknown>
): void => {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;

  if (params) {
    window.fbq('track', eventName, params);
  } else {
    window.fbq('track', eventName);
  }
};
